import {HStack, Icon, Text} from '@chakra-ui/react';
import {Link} from 'react-router-dom';
import {routes} from 'ff-common';
import {useTranslation} from 'react-i18next';
import {RiTimeLine} from 'react-icons/ri';
import {useClientRoute} from '@/hooks/auth/useClientRoute';

/**
 * Lien « Mes dernières commandes » du bloc d'accueil, vers l'historique des commandes. Pastille à
 * côté de la pastille client en version ordinateur, bouton pleine largeur sous les cartes en
 * version mobile.
 */

const STYLES_PAR_VARIANTE = {
  pastille: {
    h: '26px',
    px: '12px',
    spacing: '6px',
    borderRadius: '100px',
    borderWidth: '1.5px',
    fontSize: 'xs',
    fontWeight: '600',
    color: 'blue.text',
  },
  bloc: {
    h: '44px',
    px: '14px',
    spacing: '8px',
    borderRadius: '12px',
    borderWidth: '1px',
    fontSize: 'sm',
    fontWeight: '500',
    color: 'black.text',
    width: '100%',
    justifyContent: 'center',
  },
};

export const AccueilBoutonDernieresCommandes: React.FC<{
  variante: 'pastille' | 'bloc';
}> = ({variante}) => {
  const {t} = useTranslation();
  const {buildClientRoute} = useClientRoute();

  return (
    <HStack
      as={Link}
      to={buildClientRoute(routes.client.commandes)}
      flexShrink={0}
      borderStyle='solid'
      borderColor='gray.light'
      bg='white'
      transition='background-color 0.2s ease'
      _hover={{bg: 'gray.75'}}
      {...STYLES_PAR_VARIANTE[variante]}
    >
      <Icon
        as={RiTimeLine}
        aria-hidden
        boxSize={variante === 'pastille' ? '14px' : '16px'}
        color='blue.main'
      />
      <Text
        as='span'
        whiteSpace='nowrap'
      >
        {t('accueil.mes_dernieres_commandes')}
      </Text>
    </HStack>
  );
};
